import {
	DonationStatus,
	DonationType,
	DonationTypeLabel,
	queryClient,
	TableTitles,
} from "@/constants";
import { useWindowDimensions } from "@/hooks";
import {
	useDeleteDonationRequest,
	useGetDonationsByMeditationRetreat,
} from "@/hooks/query-hooks/useDonors";
import { Divider } from "antd";
import { useState } from "react";
import { Helmet } from 'react-helmet-async';
import {
	AnimatedComponent,
	DeleteConfirmationModal,
	PageTitle,
} from "../common";
import { AcceptDonationDrawer } from "./AcceptDonationDrawer";
import { DonationTable } from "./DonationTable";

export function DonorListComponent({
	type,
}: {
	type:
		| DonationType.EVENT_ALM
		| DonationType.DISCRETIONARY_MONEY
		| DonationType.BOHI_ETERNAL_TREE;
}) {
	const [page, setPage] = useState(1);

	const { height } = useWindowDimensions();

	const { data: donationsData, isLoading } =
		useGetDonationsByMeditationRetreat({
			page,
			type,
			status: DonationStatus.PENDING,
			queryProps: {
				enabled: !!type && page > 0,
			},
		});
	const donations = donationsData?.content || [];

	const padethaRenderColumnKeys = [
		TableTitles.donor_name,
		TableTitles.donor_phone,
		TableTitles.donation_type,
		TableTitles.donation_date,
		TableTitles.donation_payment_method,
		TableTitles.status,
		TableTitles.action,
	];

	const renderColumnKeys = [
		...padethaRenderColumnKeys,
		TableTitles.retreat_to_which_donated,
	];

	return (
		<AnimatedComponent>
			<Helmet>
				<title>{DonationTypeLabel[type]} အလှူရှင်များ</title>
			</Helmet>
			<PageTitle>{DonationTypeLabel[type]} အလှူရှင်များ</PageTitle>
			<Divider />
			<DonationTable
				dataSource={donations}
				renderColumnKeys={
					type === DonationType.BOHI_ETERNAL_TREE
						? padethaRenderColumnKeys
						: renderColumnKeys
				}
				TableActionComponent={TableActionsComponent}
				pagination={{
					current: page,
					onChange: (page) => setPage(page),
					total: donationsData?.totalElements || 0,
				}}
				scroll={{
					y: height - 336,
				}}
				loading={isLoading}
			/>
		</AnimatedComponent>
	);
}

const TableActionsComponent = ({ record }: { record: Donation }) => {
	const { mutate, isMutating } = useDeleteDonationRequest();

	const handleDeleteDonation = () => {
		mutate(record.id, {
			onSuccess: () => {
				queryClient.invalidateQueries({
					queryKey: ["donations"],
				});
			},
		});
	};

	return (
		<>
			<AcceptDonationDrawer donation={record} />
			{record.amount === 0 && (
				<DeleteConfirmationModal
					onDelete={handleDeleteDonation}
					isDeleting={isMutating}
					description="လှူဒါန်းမှုကို ဖျက်သိမ်းလိုပါသလား?"
					buttonProps={{
						danger: true,
						type: "text",
						size: "small",
					}}
				/>
			)}
		</>
	);
};
